import { getSortedFields, useFocusedField } from '@wix/form-fields';
import { useCallback } from 'react';
export const useScrollToFirstError = _ref => {
  let {
    form,
    handleStepChange,
    currentStepId
  } = _ref;
  const {
    setFocusedFieldId
  } = useFocusedField();
  const scrollToFirstError = useCallback(errors => {
    const sortedFieldsInStep = getSortedFields(form, {
      stepId: currentStepId
    });
    const fieldWithError = sortedFieldsInStep == null ? void 0 : sortedFieldsInStep.find(_field => {
      return errors.some(error => _field.target === error.errorPath.split('/')[0]);
    });
    setFocusedFieldId(fieldWithError == null ? void 0 : fieldWithError.id);
  }, [currentStepId, form, setFocusedFieldId]);
  const handleScrollToFirstError = useCallback(errors => {
    var _form$steps;
    const sortedFields = getSortedFields(form);
    const field = sortedFields == null ? void 0 : sortedFields.find(_field => {
      return errors.some(error => _field.target === error.errorPath.split('/')[0]);
    });
    if (Number((_form$steps = form.steps) == null ? void 0 : _form$steps.length) > 0) {
      var _form$steps2, _form$steps3;
      const fieldStep = (_form$steps2 = form.steps) == null ? void 0 : _form$steps2.find(step => {
        var _step$layout;
        const fieldInStep = (_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null || (_step$layout = _step$layout.items) == null ? void 0 : _step$layout.find(layoutField => layoutField.fieldId === (field == null ? void 0 : field.id));
        return Boolean(fieldInStep);
      });
      const fieldStepIndex = fieldStep && ((_form$steps3 = form.steps) == null ? void 0 : _form$steps3.indexOf(fieldStep));
      if (typeof fieldStepIndex !== 'undefined' && (fieldStep == null ? void 0 : fieldStep.id) !== currentStepId) {
        handleStepChange(fieldStepIndex);
      }
    }
    if (errors.length > 0) {
      setFocusedFieldId(field == null ? void 0 : field.id);
    }
  }, [form, currentStepId, handleStepChange, setFocusedFieldId]);
  return {
    scrollToFirstError,
    handleScrollToFirstError
  };
};
//# sourceMappingURL=use-scroll-to-first-error.js.map